module.exports = __webpack_public_path__ + "static/media/Sisodiya ji_page-0001.6070c5d2.jpg";